import {
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Stack,
    styled,
    Typography,
} from '@mui/material'
import pxToRem from '../../helpers/pxToRem'
import styles from '../index.module.scss'
import { Fragment, ReactNode } from 'react'
import { PrimaryButton } from '../Button'

export const CustomDialog = styled(Dialog)({
    '& .MuiDialog-container': {
        '& .MuiPaper-root': {
            width: '100%',
            //   maxWidth: "500px",
        },
    },

    '& .MuiDialogTitle-root': {
        padding: `${pxToRem(40)} ${pxToRem(100)}`,
        paddingBottom: 0,
    },
    '& .MuiDialogContent-root': {
        padding: pxToRem(40),
        paddingBottom: '0 !important',
        paddingTop: `${pxToRem(24)} !important`,
    },
    '& .MuiDialogActions-root': {
        padding: `${pxToRem(24)} ${pxToRem(40)} !important`,
        paddingTop: 0,
    },
})

export const CustomButton = styled(Button)({
    height: pxToRem(36),
    minWidth: pxToRem(164),
    padding: `${pxToRem(8)}px ${pxToRem(16)}px`,
    borderRadius: pxToRem(40),
    background: styles.primaryBlue500,

    color: styles.shades0,
    textAlign: 'center',
    fontSize: pxToRem(14),
    fontWeight: '400',
    lineHeight: pxToRem(20),
    letterSpacing: pxToRem(-0.28),

    '&:hover': {
        backgroundColor: styles.secondaryBlue300,
    },
})

export const CustomOutlined = styled(Button)({
    height: pxToRem(36),
    minWidth: pxToRem(164),
    padding: `${pxToRem(8)}px ${pxToRem(16)}px`,
    borderRadius: pxToRem(40),
    border: `1px solid ${styles.primaryBlue500}`,
    color: styles.primaryBlue500,

    textAlign: 'center',
    fontSize: pxToRem(14),
    fontWeight: '400',
    lineHeight: pxToRem(20),
    letterSpacing: pxToRem(-0.28),
    '&:hover': {
        color: styles.secondaryBlue300,
        borderColor: styles.secondaryBlue300,
        background: 'inherit',
    },
    '&:disabled': {
        color: styles.neutrals500,
    },
})

export const DangerButton = styled(Button)({
    height: pxToRem(36),
    minWidth: pxToRem(164),
    padding: `${pxToRem(8)}px ${pxToRem(16)}px`,
    borderRadius: pxToRem(40),
    background: styles.destructiveRed500,

    color: styles.shades0,
    textAlign: 'center',
    fontSize: pxToRem(14),
    fontWeight: '400',
    lineHeight: pxToRem(20),
    letterSpacing: pxToRem(-0.28),

    '&:hover': {
        backgroundColor: '#f56f67',
    },
    '&.Mui-disabled': {
        color: styles.neutrals500,
        backgroundColor: styles.neutrals200,
    },
})

interface IUserAlert {
    open: boolean
    handleClose: () => void
    title?: string
    content?: string | ReactNode
    handleAction?: () => void
    actionButtonText?: string
    closeButtonText?: string
    closeOutlined?: boolean
    id?: string
}

const UserAlert = (props: IUserAlert) => {
    const newlineText = (text: string) => {
        return text.split('\n').map((str, i) => (
            <Fragment key={`${props.title}_alerttext_${i}`}>
                {str}
                <br />
            </Fragment>
        ))
    }

    return (
        <CustomDialog open={props.open} sx={{ zIndex: 1302 }} id={props.id}>
            {props.title && (
                <DialogTitle>
                    <Typography
                        variant="h5"
                        textAlign={'center'}
                        fontWeight={600}
                    >
                        {props.title}
                    </Typography>
                </DialogTitle>
            )}
            <DialogContent>
                {typeof props.content === 'string' ? (
                    props.content && (
                        <Stack alignItems={'center'}>
                            <Typography
                                style={{ margin: 0, textAlign: 'center' }}
                                id={`${props.id}-content`}
                            >
                                {newlineText(props.content)}
                            </Typography>
                        </Stack>
                    )
                ) : (
                    <Stack alignItems={'center'}>{props.content}</Stack>
                )}
                <Divider sx={{ width: '100%', marginTop: `${pxToRem(40)}` }} />
            </DialogContent>
            <DialogActions
                sx={{
                    justifyContent: props.handleAction
                        ? 'space-between'
                        : 'flex-end',
                }}
            >
                <PrimaryButton
                    variant={props.closeOutlined ? 'outlined' : 'contained'}
                    onClick={props.handleClose}
                >
                    {props.closeButtonText ? props.closeButtonText : 'Close'}
                </PrimaryButton>
                {props.handleAction && (
                    <Button
                        variant="outlined"
                        color={'destructiveRed500'}
                        onClick={props.handleAction}
                    >
                        {props.actionButtonText
                            ? props.actionButtonText
                            : 'YES'}
                    </Button>
                )}
            </DialogActions>
        </CustomDialog>
    )
}

export default UserAlert
